export const logoutPortalSession = async (
  accessToken?: string | null,
  refreshToken?: string | null,
): Promise<void> => {
  if (!accessToken || !refreshToken) {
    return;
  }

  try {
    await fetch(`${process.env.REACT_APP_URL}/api/LoginPdc/Logout`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ accessToken, refreshToken }),
    });
  } catch {
    // Logout local deve continuar mesmo se a API falhar.
  }
};
